import { createAction } from 'redux-actions';
import * as actionTypes from '../constants';

export const createSmartAction = createAction(actionTypes.CREATE_SMART_ACTION);
export const createSmartActionSuccess = createAction(actionTypes.CREATE_SMART_ACTION_SUCCESS);
export const createSmartActionFailure = createAction(actionTypes.CREATE_SMART_ACTION_FAILURE);

export const saveSmartAction = createAction(actionTypes.SAVE_SMART_ACTION);
export const saveSmartActionSuccess = createAction(actionTypes.SAVE_SMART_ACTION_SUCCESS);
export const saveSmartActionFailure = createAction(actionTypes.SAVE_SMART_ACTION_FAILURE);

export const deleteSmartAction = createAction(actionTypes.DELETE_SMART_ACTION);
export const deleteSmartActionSuccess = createAction(actionTypes.DELETE_SMART_ACTION_SUCCESS);
export const deleteSmartActionFailure = createAction(actionTypes.DELETE_SMART_ACTION_FAILURE);

export const fetchSmartAction = createAction(actionTypes.FETCH_SMART_ACTION);
export const fetchSmartActionSuccess = createAction(actionTypes.FETCH_SMART_ACTION_SUCCESS);
export const fetchSmartActionFailure = createAction(actionTypes.FETCH_SMART_ACTION_FAILURE);

export const setActionForCreatingOrder = createAction(actionTypes.SET_ACTION_FOR_CREATING_ORDER);

export const updateOperations = createAction(actionTypes.UPDATE_OPERATIONS);

export const updateParts = createAction(actionTypes.UPDATE_PARTS);
export const clearPartField = createAction(actionTypes.CLEAR_PART_FIELD);

export const resetSmartActionSuccess = createAction(actionTypes.RESET_SMART_ACTION_SUCCESS);
